import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from '../auth';
import { CallPop } from './CallPop';
import { Dashboard } from './Dashboard';
import { Clients } from './Clients';
import { ClientCard } from './ClientCard';
import { Orders } from './Orders';
import { OrderCard } from './OrderCard';
import { Board } from './Board';
import { RoutesPage } from './RoutesPage';
import { Inbox } from './Inbox';
import { Devices } from './Devices';
import { Reports } from './Reports';
import { Catalog } from './Catalog';

/* Значки рисуются штрихом одного веса — набор должен читаться как один набор,
   а не как коллекция картинок из разных мест. */
const ICONS: Record<string, string> = {
  '/': 'M3 10.5 12 3l9 7.5M5.5 9.5V20h13V9.5',
  '/orders': 'M8 4h8a2 2 0 0 1 2 2v14l-6-3-6 3V6a2 2 0 0 1 2-2ZM9.5 9h5M9.5 12.5h5',
  '/board': 'M4 5h5v14H4zM15 5h5v9h-5zM11 9h2',
  '/routes': 'M6 20V8a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v12M6 20h12M4 20h16M9 20v-3h6v3M6.5 11h11',
  '/clients': 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4 20c0-3.5 3.6-5.5 8-5.5s8 2 8 5.5',
  '/inbox': 'M4 6h16v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zM4 7l8 6 8-6',
  '/catalog': 'M9 3h6l1 3v3l-1.5 2V21h-5V11L8 9V6zM10 6h4',
  '/reports': 'M5 20V11M10 20V5M15 20v-6M20 20V8',
  '/devices': 'M8 3h8a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1ZM10.5 18h3',
};

const NAV = [
  { to: '/', label: 'Сводка', end: true },
  { to: '/orders', label: 'Заказы' },
  { to: '/board', label: 'Доска' },
  { to: '/routes', label: 'Маршруты' },
  { to: '/clients', label: 'Клиенты' },
  { to: '/inbox', label: 'Сообщения' },
  { to: '/catalog', label: 'Товары' },
  { to: '/reports', label: 'Отчёты' },
  { to: '/devices', label: 'Телефоны' },
];

function NavIcon({ to }: { to: string }) {
  return (
    <svg className="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={ICONS[to]} />
    </svg>
  );
}

export function OperatorShell() {
  const { me, logout } = useAuth();
  const role = me?.scope === 'staff' ? me.user.role : '';

  // Водителя рабочее место не интересует — ему нужен маршрут
  if (role === 'DRIVER') return <Navigate to="/driver" replace />;

  return (
    <div className="shell">
      <aside className="side">
        <div className="logo">
          <img src="/logo.png" alt="Логотип" />
        </div>
        <nav>
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => (isActive ? 'active' : '')}>
              <NavIcon to={n.to} />
              <span>{n.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="who">
          {me?.scope === 'staff' ? me.user.name : ''}
          <br />
          <button className="ghost" style={{ padding: '4px 0' }} onClick={logout}>
            Выйти
          </button>
        </div>
      </aside>

      <main className="main">
        <Routes>
          <Route index element={<Dashboard />} />
          <Route path="orders" element={<Orders />} />
          <Route path="orders/:id" element={<OrderCard />} />
          <Route path="board" element={<Board />} />
          <Route path="routes" element={<RoutesPage />} />
          <Route path="clients" element={<Clients />} />
          <Route path="clients/:id" element={<ClientCard />} />
          <Route path="inbox" element={<Inbox />} />
          <Route path="catalog" element={<Catalog />} />
          <Route path="reports" element={<Reports />} />
          <Route path="devices" element={<Devices />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      {/* Карточка звонящего висит поверх любого экрана: звонок приходит
          тогда, когда оператор занят чем-то другим */}
      <CallPop />
    </div>
  );
}
